import { render, staticRenderFns } from "./payment-config-page.vue?vue&type=template&id=274dc0c8&"
import script from "./payment-config-page.vue?vue&type=script&lang=ts&"
export * from "./payment-config-page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports